/**
 * 获取当前域名 http(s)://xxx.xxx
 * @returns
 */
const getAll = () => {
  let prefix = 'http://'
  if (window.location.href.startsWith('https')) {
    prefix = 'https://'
  }
  return `${prefix}${window.location.host}`
}

/**
 * 获取域名 www.xx.com 这种，不带端口
 * @returns 
 */
const getHostname = () => {
  return window.location.hostname
}

const isLocal = () => {
  return window.location.host.includes('localhost')
}

export const useHost = () => ({ getAll, isLocal, getHostname })
